import { useDefinedQuery } from '@/hooks/useDefinedQuery'
import type { QueryDef } from '@/hooks/useDefinedQuery'
import { getCollectionQuantitiesByBase, getCollectionItemByCard } from '@/services/api/collection'
import type { CollectionItem } from '@/types'
import { COLLECTION_KEYS } from './collectionKeys'

const collectionQueries = {
  quantitiesByBase: {
    queryKey: COLLECTION_KEYS.quantitiesByBase,
    queryFn: getCollectionQuantitiesByBase,
    auth: 'required',
  } satisfies QueryDef<Awaited<ReturnType<typeof getCollectionQuantitiesByBase>>>,
}

export function useCollectionQuantitiesByBase() {
  return useDefinedQuery(collectionQueries.quantitiesByBase)
}

const collectionItemByCardQuery = {
  queryKey: (cardId: number) => ['collectionItemByCard', cardId] as const,
  queryFn: (cardId: number) => getCollectionItemByCard(cardId),
  auth: 'required',
} satisfies QueryDef<CollectionItem | null, [number]>

/**
 * Fetches the current user's collection item for a given card (or null if they don't own it).
 * Used by the card detail page to show condition and other per-item metadata.
 */
export function useCollectionItemByCard(cardId: number | undefined) {
  return useDefinedQuery(collectionItemByCardQuery, (cardId ?? 0) as number, { enabled: Boolean(cardId) })
}
